<template>
  <v-dialog v-model="show" max-width="1500" persistent>
    <v-card style="padding:15px;">
      <v-card-title> Agregar fraccion arancelaria</v-card-title>

      <v-container>
        <v-row>
          <v-col cols="3">
            <template>
              <div class="mt-2" v-for="(item, index) in multiEnviosIterables" :key="index">
                <span style="font-size:20px;font-weight:bold;">Paquete #{{ index + 1 }}</span>

                <v-btn color="purple" dark @click="aCualEnvioAgregarFA(index)"
                  >agregar fraccion arancelaria</v-btn
                >
                <br />
                <div class="mt-2" v-for="(fax, i) in item.fa" :key="i">
                  <span class="ml-4" style="font-size:20px;font-weight:bold;"
                    >Fraccion #{{ i + 1 }}
                    <v-btn color="red" dark @click="eliminarFA(index, i)"
                      >eliminar fraccion arancelaria</v-btn
                    > </span
                  ><br />
                  <span>Clave fraccion arancelaria: {{ fax.num_clasificacion }}</span
                  ><br />
                  <span>Descripcion: {{ fax.des_en }}</span>

                  <v-text-field
                    dense
                    @input="calculaTotalSubtotalesYTotalTotal()"
                    @focus="$event.target.select()"
                    type="number"
                    outlined
                    label="Cantidad"
                    v-model="fax.cantidad"
                  ></v-text-field>
                  <v-text-field
                    style="margin-bottom:-15px;"
                    dense
                    @input="calculaTotalSubtotalesYTotalTotal()"
                    type="number"
                    outlined
                    @focus="$event.target.select()"
                    label="Precio unitario"
                    v-model="fax.valor_unitario"
                  ></v-text-field>
                  <v-chip color="cyan darken-1" dark> Subtotal: {{ fax.subtotal }} </v-chip>
                  <span></span><br />
                </div>
              </div>
              <v-chip class="mt-1" color="blue" dark>Total final: {{ totalTotal }}</v-chip>
              <span></span>
            </template>
          </v-col>
          <v-col class="6">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  dense
                  label="Búsqueda..."
                  v-model="textoBusqueda"
                  single-line
                  clearable
                  @input="consultaFraccionesArancelarias()"
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-alert v-if="mostrarErrorCarga" outlined type="error">
                  Hubo un problema cargando la información, revise su conexión a internet e intente
                  nuevamente.
                </v-alert>
                <v-data-table
                  loading-text="Cargando... por favor espere."
                  :loading="tableLoading"
                  :headers="headers"
                  :items="fraccionesAList"
                  class="elevation-1"
                  hide-default-footer
                >
                  <template #item.actions="{ item }">
                    <v-btn
                      @click="insertarFraccionEnvioActual(item)"
                      color="blue"
                      class="mr-2"
                      text
                      rounded
                      dark
                    >
                      Agregar
                      <v-icon small class="mr-2">
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                <v-pagination
                  @input="consultaFraccionesArancelarias(1)"
                  v-model="page"
                  :length="this.totalPaginas"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="$emit('cerrar-modal-fa')" text>Cancelar</v-btn>
        <v-btn
          color="blue darken-1"
          @click="
            insertaFracciones();
            $emit('cerrar-modal-fa');
          "
          text
          >Aceptar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackBarFraccionArancelariaEnvio"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;text-align:center;">
        {{ msgSnackBarFraccionArancelariaEnvio }}
      </span></v-snackbar
    >
  </v-dialog>
</template>
<script>
import _ from "lodash";
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    snackBarFraccionArancelariaEnvio: false,
    msgSnackBarFraccionArancelariaEnvio: "",
    totalTotal: 0,
    mostrarErrorCarga: false,
    page: 1,
    itemsPerPage: 10,
    search: "",
    tableLoading: false,
    textoBusqueda: "",
    indiceAgregarFAs: 0,
    multiEnviosIterables: [],
    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "NOMBRE"
      },
      {
        text: "Clave",
        align: "start",
        sortable: false,
        value: "NUM_CLASIFICACION"
      },
      {
        text: "Descripcion",
        align: "start",
        sortable: false,
        value: "DES_ES"
      },
      {
        text: "Descripcion inglés",
        align: "start",
        sortable: false,
        value: "DES_EN"
      },
      {
        text: "",
        align: "start",
        sortable: false,
        value: "actions"
      }
    ]
  }),
  async mounted() {
    // console.log(this.multiEnviosDatos, "datos llegados a modal");

    this.multiEnviosIterables = JSON.parse(JSON.stringify(this.multiEnviosDatos));
    const res = await this.getFraccionasA({
      pag: this.page,
      regPag: this.itemsPerPage
    });
    await this.calculaTotalSubtotalesYTotalTotal();
  },
  computed: {
    ...mapState("fraccionesarancelarias", {
      fraccionesAList: state => state.listaFA,
      totalPaginas: state => state.totalPaginas
    })
  },
  onDestroy() {
    this.multiEnviosIterables = [];
  },
  methods: {
    ...mapActions("fraccionesarancelarias", ["getFraccionasA", "destroyFraccionesAStore"]),
    async calculaTotalSubtotalesYTotalTotal() {
      await this.calculaTotalSubtotales();
      await this.calculaTotalTotal();
      await this.calculaTotalSubtotales();
      await this.calculaTotalTotal();
    },
    async calculaTotalSubtotales() {
      for (let i = 0; i < this.multiEnviosIterables.length; i++) {
        for (let j = 0; j < this.multiEnviosIterables[i].fa.length; j++) {
          this.multiEnviosIterables[i].fa[j].subtotal = (
            parseFloat(this.multiEnviosIterables[i].fa[j].cantidad).toFixed(2) *
            parseFloat(this.multiEnviosIterables[i].fa[j].valor_unitario).toFixed(2)
          );
          this.multiEnviosIterables[i].fa[j].subtotal=this.multiEnviosIterables[i].fa[j].subtotal.toFixed(2);
        }
      }
    },
    async calculaTotalTotal() {
      var arregloSubtotales = [];
      for (var i = 0; i < this.multiEnviosIterables.length; i++) {
        for (var j = 0; j < this.multiEnviosIterables[i].fa.length; j++) {
          arregloSubtotales.push(this.multiEnviosIterables[i].fa[j].subtotal);
        }
      }
      if (arregloSubtotales.length > 0) {
        this.totalTotal = arregloSubtotales.reduce((a, b) => parseFloat(a) + parseFloat(b));
        this.totalTotal=this.totalTotal.toFixed(2);
      }
    },
    async insertarFraccionEnvioActual(fa) {
      let todasLasFracciones = [];
      let hayDuplicados = false;
      var counts = {};

      for (let i = 0; i < this.multiEnviosIterables[this.indiceAgregarFAs].fa.length; i++) {
        if (fa.ID == this.multiEnviosIterables[this.indiceAgregarFAs].fa[i].id) {
          hayDuplicados = true;
        }
      }
      if (!hayDuplicados) {
        //asi obtenemos todos los id de todas las fracciones agregadas al envio
        for (let i = 0; i < this.multiEnviosIterables.length; i++) {
          for (let j = 0; j < this.multiEnviosIterables[i].fa.length; j++) {
            todasLasFracciones.push(this.multiEnviosIterables[i].fa[j].id);
          }
        }
        let sinRepetidos = todasLasFracciones.filter(
          (valor, indiceActual, arreglo) => arreglo.indexOf(valor) === indiceActual
        );
        console.log(sinRepetidos, fa.ID);
        if (sinRepetidos.length == 7) {
          hayDuplicados = true;
          //if (sinRepetidos.includes(fa.ID)) hayDuplicados = true;
        }
        if (!hayDuplicados) {
          this.multiEnviosIterables[this.indiceAgregarFAs].fa.push({
            id: fa.ID,
            nombre: fa.NOMBRE,
            num_clasificacion: fa.NUM_CLASIFICACION,
            des_en: fa.DES_EN,
            cantidad: 0,
            valor_unitario: 0,
            subtotal: 0
          });
        } else {
          this.msgSnackBarFraccionArancelariaEnvio =
            "El límite de fracciones arancelarias por envío es de 7";
          this.snackBarFraccionArancelariaEnvio = true;
        }
      } else {
        this.msgSnackBarFraccionArancelariaEnvio =
          "No se pueden duplicar fracciones arancelarias en el mismo paquete";
        this.snackBarFraccionArancelariaEnvio = true;
      }
    },
    insertaFracciones() {
      this.$emit("insertaFraccionesEnInfoEnvios", this.multiEnviosIterables);
    },
    eliminarFA(index, index2) {
      // console.log(this.multiEnviosIterables[index]);
      this.multiEnviosIterables[index].fa.splice(index2, 1);
    },
    aCualEnvioAgregarFA(indexEnvioAgregarFa) {
      this.msgSnackBarFraccionArancelariaEnvio = `Editando envio número ${parseInt(
        indexEnvioAgregarFa + 1
      )}`;
      this.snackBarFraccionArancelariaEnvio = true;
      this.indiceAgregarFAs = indexEnvioAgregarFa;
    },
    consultaFraccionesArancelarias: _.debounce(async function(data = 0) {
      if (data === 1) {
      } else {
        this.page = 1;
      }
      console.log(data);
      this.tableLoading = true;
      if (this.textoBusqueda != "") {
        const res = await this.getFraccionasA({
          pag: this.page,
          regPag: this.itemsPerPage,
          textoBusqueda: this.textoBusqueda
        });
        if (res[0]) {
          this.tableLoading = false;
        } else if (res[1] === "errorcarga") {
          this.mostrarErrorCarga = true;
        }
      } else {
        const res = await this.getFraccionasA({
          pag: this.page,
          regPag: this.itemsPerPage
        });
        if (res[0]) {
          this.tableLoading = false;
        } else if (res[1] === "errorcarga") {
          this.mostrarErrorCarga = true;
        }
      }
    }, 400)
  },
  props: {
    show: Boolean,
    multiEnviosDatos: Array
  }
};
</script>
